module.exports = __webpack_public_path__ + "img/img-development-step-03.png";